import { useMutation, useQueryClient } from "@tanstack/react-query";
import moment from "jalali-moment";
import React, { useEffect, useState } from "react";
import {
  approveComment,
  deleteComment,
  sendComment,
} from "../../../service/api";
import { wordpressCommentsUiHelper } from "../../../helpers/wordpressUiHelper";
import { Button } from "antd";

function Comment({ comment, comments }) {
  const queryClient = useQueryClient();
  const [openTextInput, setOpenTextInput] = useState(false);
  const [commentData, setCommentData] = useState();
  const [commentReply, setCommentReply] = useState();



  useEffect(() => {
    if (comment) {
      setCommentData(wordpressCommentsUiHelper(comment));
    }
  }, [comment]);

  const sendCommentMutation = useMutation(sendComment, {
    onSuccess: () => {
      setOpenTextInput((prev) => !prev);
      queryClient.invalidateQueries(["comments"]);
    },
  });

  const approveCommentMutation = useMutation(approveComment, {
    onSuccess: () => {
      queryClient.invalidateQueries(["comments"]);
    },
  });

  const deleteCommentMutation = useMutation(deleteComment, {
    onSuccess: () => {
      queryClient.invalidateQueries(["comments"]);
    },
  });

  const sendCommentReply = () => {
    // id: _?.id,
    // showReplyBtn: false,
    // selfComment: false,
    // author: _?.author,
    // avatar: _?.author_avatar_urls["96"],
    // author_email: "test@email.com",
    // // author_name:
    // //   JSON.parse(localStorage.getItem("profile"))["firstName"] +
    // //   " " +
    // //   JSON.parse(localStorage.getItem("profile"))["lastName"],
    // author_name: _?.author_name,
    // post: _?.post,
    // content: _?.content?.rendered,
    // parent: _?.parent,
    // date: _?.date

    // delete commentData
    sendCommentMutation.mutate(commentReply);
  };

  const openReplyInput = () => {
    const expertProfile = JSON.parse(localStorage.getItem("profile"));
    setCommentReply({
      ...commentReply,
      author: expertProfile.wordpressAuthorId,
      author_name: `${expertProfile.firstName} ${expertProfile.lastName}`,
      post: commentData?.post,
      parent: commentData?.id,
    });
    setOpenTextInput((prev) => !prev);
  };

  return (
    <div
      key={commentData?.id}
      className={`${commentData?.selfComment ? "self-end" : "self-start"} shadow flex flex-col items-start gap-4 max-lg:gap-3 w-2/3 max-lg:w-5/6  ${
        openTextInput ? "h-[336px]" : "h-fit"
      } p-4 rounded-lg bg-gray-200`}
    >
      {/* comment parent */}
      {commentData?.parent ? (
        //todo add reply icon before div please :)
        <div
          className="w-full text-xs bg-yellow-50 h-9 rounded-lg flex justify-start items-center p-2"
          dangerouslySetInnerHTML={{
            __html: comments.find((c) => c?.id === commentData?.parent)?.content
              ?.rendered,
          }}
        />
      ) : null}

      {/* avatar and name */}
     {comment.selfComment ? <div className="flex text-base max-lg:text-sm gap-2 w-full justify-end items-center ">
        <p>{commentData?.author_name}</p>
        <img className="w-11 rounded-3xl " alt=""src={commentData?.avatar} />
      </div> :
      <div className="flex text-base max-lg:text-sm gap-2 items-center">
      <img className="w-11 rounded-3xl " alt=""src={commentData?.avatar} />
      <p>{commentData?.author_name}</p>
    </div>
      }
<div className="w-full bg-slate-400 h-[0.9px] flex justify-end   lg:hidden"></div>
      {/* content */}
      <div
        className="mr-10 max-lg:text-justify max-lg:mr-0 max-lg:text-sm"
        dangerouslySetInnerHTML={{ __html: commentData?.content }}
      />

      {/* reply button and date */}
      <div className="w-full mt-4 text-xs flex justify-between">
        {/* reply button */}
        <>
          {commentData?.showReplyBtn ? (
            <p
              className="text-green-800 cursor-pointer"
              onClick={openReplyInput}
            >
              پاسخ دادن
            </p>
          ) : (
            <div className="flex flex-row m-auto gap-4">
              <Button
                className="text-green-800 cursor-pointer"
                onClick={() => approveCommentMutation.mutate(commentData?.id)}
                loading={approveCommentMutation?.isLoading}
              >
                تایید
              </Button>
              <Button
                className="text-red-800 cursor-pointer"
                onClick={() => deleteCommentMutation.mutate(commentData?.id)}
                loading={deleteCommentMutation?.isLoading}
              >
                حذف
              </Button>
            </div>
          )}
        </>

        {/* date */}
        <p>
          {commentData?.date &&
            moment(commentData?.date, "YYYY/MM/DD")
              .locale("fa")
              .format("YYYY/MM/DD")}
        </p>
      </div>

      {/* text input */}
      {openTextInput && (
        <div className="mt-4 h-8 w-full">
          <textarea
            type="text"
            className="w-full h-24 rounded-lg p-2 text-start"
            onChange={(e) =>
              setCommentReply({ ...commentReply, content: e?.target?.value })
            }
          />
          <Button
            className="bg-green-600 w-20 py-2 rounded-lg font-body self-end"
            onClick={sendCommentReply}
            loading={sendCommentMutation?.isLoading}
          >
            ارسال
          </Button>
        </div>
      )}
    </div>
  );
}

export default Comment;
